module.exports = __webpack_public_path__ + "img/header-engagementRings050Carat@2x.a25dc34.webp";